"use client";

import { useLanguage } from "@/i18n/LanguageContext";

export default function GlossaryBox() {
  const { currentLang, t } = useLanguage();
  const isEs = currentLang === "es";

  const terms = [
    {
      term: "HVHZ",
      defEn: "High-Velocity Hurricane Zone (Miami-Dade, Broward). The only US region requiring large-missile impact testing for residential openings.",
      defEs: "Zona de Huracanes de Alta Velocidad (Miami-Dade, Broward). La única región de EE.UU. que requiere pruebas de impacto de misiles grandes para aberturas residenciales.",
    },
    {
      term: "NOA",
      defEn: "Notice of Acceptance. Miami-Dade product approval certificate issued after TAS testing and engineering review.",
      defEs: "Aviso de Aceptación. Certificado de aprobación de productos de Miami-Dade emitido tras pruebas TAS y revisión de ingeniería.",
    },
    {
      term: "TAS 201",
      defEn: "Large Missile Impact Test. A 9-pound 2x4 fired at 50 ft/sec against the product surface.",
      defEs: "Prueba de Impacto de Misil Grande. Una madera 2x4 de 9 libras disparada a 50 pies/seg contra la superficie del producto.",
    },
    {
      term: "TAS 202",
      defEn: "Uniform Static Air Pressure Test. Verifies the product resists sustained wind pressure without deflection failure.",
      defEs: "Prueba de Presión de Aire Estática Uniforme. Verifica que el producto resista presión de viento sostenida sin falla por deflexión.",
    },
    {
      term: "TAS 203",
      defEn: "Cyclic Wind Pressure Loading Test. Simulates repeated positive and negative wind cycles over 3,000+ repetitions.",
      defEs: "Prueba de Carga de Presión de Viento Cíclica. Simula ciclos de viento positivos y negativos repetidos en 3,000+ repeticiones.",
    },
    {
      term: "PCA",
      defEn: "Product Control Approval. The formal approval process managed by Miami-Dade County Product Control Section.",
      defEs: "Aprobación de Control de Producto. El proceso formal de aprobación gestionado por la Sección de Control de Productos del Condado Miami-Dade.",
    },
    {
      term: "WBDR",
      defEn: "Wind-Borne Debris Region. Statewide coastal zone within one mile of the shore requiring protected openings.",
      defEs: "Región de Escombros Impulsados por Viento. Zona costera a nivel estatal dentro de una milla de la costa que requiere aberturas protegidas.",
    },
    {
      term: "WLZ",
      defEn: "Wind Loaded Zone classification. Assigned per ASCE 7-22 based on site location, height, and exposure.",
      defEs: "Clasificación de Zona de Carga de Viento. Asignada según ASCE 7-22 basada en ubicación, altura y exposición del sitio.",
    },
  ];

  return (
    <section className="bg-[#fefce8] py-10 px-8 rounded-xl border-l-4 border-[#064e3b] my-12">
      <h3 className="text-2xl font-bold text-[#064e3b] mb-6">{t("blog.codes.glossaryHeading")}</h3>
      <div className="grid grid-cols-1 sm:grid-cols-2 gap-x-8 gap-y-4">
        {terms.map((item) => (
          <div key={item.term}>
            <p className="font-bold text-[#064e3b] text-sm">{item.term}</p>
            <p className="text-sm text-gray-600 mt-1 leading-relaxed">{isEs ? item.defEs : item.defEn}</p>
          </div>
        ))}
      </div>
    </section>
  );
}